export default __webpack_public_path__ + "static/media/02.7afca4b5.jpg";